import React, { Component } from "react";
import "./App.css";

import PageContainer from "../pageContainer";

class App extends Component {
  render() {
    return (
      <div className="App">
        <PageContainer />
      </div>
    );
  }
}

export default App;
